module.exports = __webpack_public_path__ + "assets/icn-checked-green.74e3bd9b.svg";